﻿import $ from 'jquery';

$(document).ready(() => {
  $(window).on('scroll load ready resize', (event) => {
    onScroll();
    onScrollNews();
  });
  //$('body').scroll(function () {
  //    onScroll();
  //});
});
function onScrollNews(){
  const   scrollTopNews = $(window).scrollTop();
  const  formContainerNews = $('.card-form-container');
  const glueCardNews = 260;
  const translateYCardNews = 0;
  const menuHeightNews = $('#menu').height();

  if(formContainerNews.length == 0)
    return;
    //News Var
  const cardNews =  $('.cardNews');
  const newsHeight = cardNews.outerHeight();
  const maxScrollNews = menuHeightNews  + glueCardNews;
  const footerNews =  $('footer').offset().top + glueCardNews;
  const maScrollBtmNews = (scrollTopNews + newsHeight + maxScrollNews + glueCardNews);
  if (isMobile()) {
    returnToDefault();
    //if (scrollTop >= formContainerNews.offset().top + formHeight) {
    //    $('#form_button').show();
    //} else {
    //    $('#form_button').hide();
    //}
    return;
  }

  //News Component
  if (scrollTopNews > maxScrollNews) {
    if (maScrollBtmNews <= footerNews) {
      let top = menuHeightNews + glueCardNews;
      cardNews.css({
        width: `${formContainerNews.outerWidth()}px`,
        left: `${formContainerNews.offset().left}px`,
        position: 'fixed',
        top: `${top}px`,
        transform: 'translateY(0)'
      });
    } else {
      let top = footerNews - newsHeight - formContainerNews.offset().top - glueCardNews
      cardNews.css({
        width: '100%',
        left: 0,
        position: 'absolute',
        top: `${top}px`,
        transform: 'translateY(0)'
      });
    }

  } else {
    returnToDefaultNews();
  }

  function returnToDefaultNews() {
    cardNews.css({
      left: 0,
      width: '100%',
      position: 'relative',
      top: 'auto',
      transform: `translateY(-${translateYCardNews}%)`,
    });
  }
}

function onScroll() {
  const glue = 80;
  const translateY = 75;
  const menu = $('#menu');
  const scrollTop = $(window).scrollTop();
  const formContainer = $('.card-form-container');
  if(formContainer.length == 0)
    return;
  //Form Var
  const formContent = $('.card-form');
  const formHeight = formContent.outerHeight();
  const formTop = formContainer.offset().top - (formHeight * translateY / 100);
  const menuHeight = $('#menu').height();
  const maxScrollTop = menuHeight + glue;
  const footerTop = $('footer').offset().top;
  const maScrollBottom = (scrollTop + formHeight + maxScrollTop + glue);


  //Form component
  if (scrollTop > maxScrollTop) {
    if (maScrollBottom <= footerTop) {
      const top = menuHeight + glue;
      formContent.css({
        width: `${formContainer.outerWidth()}px`,
        left: `${formContainer.offset().left}px`,
        position: 'fixed',
        top: `${top}px`,
        transform: 'translateY(0)'
      });
    } else {
      const top = footerTop - formHeight - formContainer.offset().top - glue
      formContent.css({
        width: '100%',
        left: 0,
        position: 'absolute',
        top: `${top}px`,
        transform: 'translateY(0)'
      });
    }

  } else {
    returnToDefault();
  }
  function returnToDefault() {
    formContent.css({
      left: 0,
      width: '100%',
      position: 'relative',
      top: 'auto',
      transform: `translateY(-${translateY}%)`,
    });
  }

}

function isMobile() {
  return $("#isMobile").is(':visible');
}